import api from './api';

export const surveyService = {
    // PUBLIC: Kirim survey
    submitSurvey: async (data) => {
        try {
            const response = await api.post('/survey', data);
            return {
                success: true,
                data: response.data,
                message: response.data.message,
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengirim survey',
                errors: error.response?.data?.errors,
            };
        }
    },

    // PUBLIC: Get statistik kepuasan (untuk footer)
    getSatisfaction: async () => {
        try {
            const response = await api.get('/survey/satisfaction');
            return { success: true, data: response.data.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat statistik' };
        }
    },

    // ADMIN: Get list survey
    getList: async (params = {}) => {
        try {
            const response = await api.get('/survey-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat data' };
        }
    },

    // ADMIN: Get detail
    getDetail: async (id) => {
        try {
            const response = await api.get(`/survey-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat detail' };
        }
    },

    // ADMIN: Update status
    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/survey-admin/${id}/status`, { status });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },

    // ADMIN: Delete
    delete: async (id) => {
        try {
            const response = await api.delete(`/survey-admin/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    // ADMIN: Statistics
    getStatistics: async () => {
        try {
            const response = await api.get('/survey-admin/statistics');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat statistik' };
        }
    },
};

export default surveyService;